import { render } from "./ModalConnectAirwallex.vue?vue&type=template&id=09d242f1&scoped=true"
import script from "./ModalConnectAirwallex.vue?vue&type=script&lang=js"
export * from "./ModalConnectAirwallex.vue?vue&type=script&lang=js"

import "./ModalConnectAirwallex.vue?vue&type=style&index=0&id=09d242f1&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d242f1"]])

export default __exports__